import React, { Component } from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {API} from "aws-amplify";
import {prosLog, prosLogDt, reserveAwsApi} from "../prodect/ProsConnect";
import {prosNotificationShow} from "../prodect/ProsPopup";
import {DEBUG_LOG_SENDING_TO_AWS} from "../prodect/ProsConnect";
import {prosLogX} from "../prodect/ProsConnect";
import {v4 as uuidv4} from "uuid";
import {setHelpContext} from "../prodect/HelpManager";
import FileUploader from "../components/FileUploader";
import BasicButton from "../components/BasicButton";
import Spacer from "../components/Spacer";

export default class ExcelImportExport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedFile: null,
            isOperationCompleted: false,
            prevMode: null,
            excelMode: null
        };
    }

    componentDidMount() {
        setHelpContext('excel')
    }

    async synchExcelWithAws(fileName) {
        // prosLog('Starting excel update');
        let project = prosConnect.getActiveProject()
        if (!project) {
            alert("Project is not active")
            return
        }
        let payload = {
            email: prosConnect.getUserEmail(true),
            projects: [project.getPid()],
            version: 2
        };
        if (fileName) {
            payload.inputFile = fileName;
        }
        if ( DEBUG_LOG_SENDING_TO_AWS) {
            prosLogX("POST TO AWS - Excel upload");
            prosLogX('fileName:', fileName);
        }
        try {
            await reserveAwsApi(true, 'POST req Excel update')
            let response = await API.post("prodect",'/excel', {body: payload});
            prosLog('Exel req:', payload, ', responce:', response)
        } catch (e) {
            prosConnect.checkAwsApiException(e)
        }
        await reserveAwsApi(false, 'POST req Excel update')
    }

    isFileSelected() {
        return this.state.selectedFile != null;
    }

    handleImport = async (file) => {
        if (!prosConnect.hasPermissionTo("excelExport")) {
            this.props.notif("Ei tarvittavaa käyttöoikeutta projektiin");
            return;
        }
        if (file.name.indexOf('.xlsx') < 0) {
            this.props.notif("Tuki vain Excel .xlsx, valitse uudelleen");
            return;
        }
        this.setState({
            isLoading: true
        });
        prosLogDt('### handleImport() - fileName:', file);
        let s3FileName = prosConnect.getDevId() + '_' + uuidv4() + '.xlsx'
        prosLogDt('### handleImport() - s3FileName:', s3FileName);
        let s3Key = await prosConnect.startFileUpload(file, false, prosConnect.S3_EXCEL_IN_FOLDER, s3FileName)
        prosLogDt('### handleImport() - s3Key:', s3Key);
        this.synchExcelWithAws(prosConnect.S3_EXCEL_IN_FOLDER + s3Key)
        this.setState({
            isLoading: false,
            isOperationCompleted: true,
            excelMode: 'import',
            selectedFile: null
        })
        prosNotificationShow(this, 'Tiedoston tuonti valmis.')
    }

    handleExport =()=> {
        this.synchExcelWithAws();
        this.setState({
            isLoading: false,
            isOperationCompleted: true,
            excelMode: 'export'
        })
        prosNotificationShow(this, 'Tiedoston vienti valmis.')
    }

    renderFileImporter(){
        return <FileUploader formats={['.xlsx']}
            fileslimit={1}
            confirmUpload={true}
            callback={files => {
                if(files != null) this.handleImport(files[0])
            }}
        />
    }

    renderImport() {
            if(this.state.excelMode === 'import' && !this.state.selectedFile && this.state.isOperationCompleted){
                return (
                    <form onSubmit={ () => this.props.closePage()  }>
                        <p>Palvelin tarkistaa ja päivittää tietoja annetusta Excel tiedostosta.</p>
                        <p>Saat hetken kuluttua sähköpostin, jossa on yhteenveto päivityksen onnistumisesta
                            sekä linkki päivitettyyn Excel tiedostoon.</p>
                        <p>Jos päivityksessä tapahtui virheitä, voit ladata päivitetyn
                            Excel tiedostosi ja tarkistaa kultakin riviltä virheen syyn.</p>
                        <BasicButton
                            btnClass={"primary"}
                            label={this.state.isLoading ? "Odota hetki" : "OK"}
                            loading={this.state.isLoading}
                            buttonType={"submit"}
                        />
                    </form>
                )
            }
            if (!this.isFileSelected()) {
                return <>
                    <p> Valitse Excel tiedosto josta siirretään tietoja Prodect tietokantaan.</p>
                    <p> Jos et ole tehnyt tiedostoa valitse ensin "Vie Excel tiedostoksi" toiminto,
                        josta saat projektin tiedot Excel tiedostona. </p>
                    <p> Excelissä on ohjesivu miten lisätä, päivittää tai poistaa Prodect tietoja Excel
                        taulukon avulla.</p>
                    {this.renderFileImporter()}
                </>
            }
    }

    renderExport() {
            if (!this.state.isOperationCompleted || this.state.excelMode === 'import') {
                return <>
                    <p>Aloita Excel tiedoston tekeminen osaprojektin <strong>{prosConnect.getActiveSubProjectName()}</strong> kirjauksista.<br/>Saat hetken kuluttua sähköpostiin linkin, josta voit ladata tiedoston.</p>
                    <BasicButton
                        btnClass={"primary"}
                        icon={"export"}
                        label={"Tee Excel"}
                        action={()=> this.handleExport()}
                    />
                </>
            }

        return <>
            <p>Palvelin tekee Excel tiedostoa - saat sen hetken kuluttua sähköpostiisi.</p>
        </>
    }

    renderFileImport(){
        if(!prosConnect.getActiveProject().isProjectActive()){
            return null
        }
        return <>
            <Spacer line={true} size={"lg"}/>
            <div className={"sub-container width-50_xl"}>
                <h2>Tuo Excel-tiedosto</h2>
                <div className={"flex-center"}>{this.renderImport()}</div>
            </div>
        </>
    }
    render() {
        return (
            <>
                <h1>Excel-toiminnot</h1>
                <section>
                    <div className={"sub-container"}>
                        <h2>Vie Excel-tiedosto</h2>
                        {this.renderExport()}
                    </div>
                    {this.renderFileImport()}
                </section>
            </>
        )
    }
}
